import React from 'react'

import pill from "./../../../UI/general/pill.svg"
import collapse from './../../../UI/general/collapse.svg'

interface Props {
  isQuotationModalOpened: boolean,
  handleOpenQuoationModal: any
}

interface State {
  selectedAptosCollapsed: boolean
}

class QuotationModalMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      selectedAptosCollapsed: true
    }
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.isQuotationModalOpened ? "quotation-modal-container-opened-mobile":"quotation-modal-container-closed-mobile"}>
          <div className='close-quotation-modal-mobile' onClick = {() => {this.props.handleOpenQuoationModal()}}>
            <img src={pill} alt=""/> 
          </div>
          <div className='quotation-info-container-mobile'>
            <div className='quotation-info-name-mobile'>Cotización</div>
            <div className='quotation-info-text-mobile'>Llena los campos y recibirás en tu correo más información de los inmuebles.</div>
            <div className='quotation-info-inputs-container-mobile'>
              <input type={"text"} placeholder='Nombres'></input>
              <input type={"number"} placeholder='Teléfono'></input>
              <input type={"email"} placeholder='Correo electrónico'></input>
            </div>
            <div className='selected-properties-container-mobile'>
              <div className='selected-properties-header' onClick = {() => {this.setState({selectedAptosCollapsed: !this.state.selectedAptosCollapsed})}}>
                <div>{("inmuebles seleccionados").toUpperCase()}</div>
                <img src={collapse} alt=""/>
              </div>
              {
                this.state.selectedAptosCollapsed ?
                null:
                <div className='quotation-selected-individual-container-mobile'>
                  <div className='quotation-selected-individual-mobile'></div>
                  <div className='quotation-selected-individual-mobile'></div>
                  <div className='quotation-selected-individual-mobile'></div>
                  <div className='quotation-selected-individual-mobile'></div>
                  <div className='quotation-selected-individual-mobile'></div>
                </div>
              }
            </div>
            <div className='quotation-send-btn-mobile'>
              Enviar
            </div>
            <div className='quotation-legal-text-mobile'>
              Al presionar <b>ENVIAR</b> estoy aceptando todos los térmios y condiciones tratados en nuestra <a href='/'>Declaración de Privacidad</a>
            </div>
          </div>
        </div>
      )
  }
}

export default QuotationModalMobile